import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/joy";
import { Slide, useMediaQuery } from "@mui/material";
import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import DialogClose from "../dialogClose/dialogClose";

export default function SlidingDialog({
  children,
  onClose,
  open,
}: {
  children: ReactElement;
  onClose: () => void;
  open: boolean;
}) {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <DialogClose
      open={open}
      TransitionComponent={Transition as any}
      fullScreen
      sx={
        !sm && {
          margin: "70px auto auto auto",
          height: "calc(100% - 40px)",
          borderRadius: "8px",
          maxWidth: "90vw",
          padding: 0,
        }
      }
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      {children}
    </DialogClose>
  );
}

export const Transition = React.forwardRef(function Transition(
  props: any,
  ref
) {
  return (
    <Slide direction="up" ref={ref} {...props}>
      {props.children}
    </Slide>
  );
});
